<!-- FORMULARIO PARA AGREGAR CONDICIONES A PROMOCIONES-->
<form [formGroup]="agregarFormCondicion">    
    <div class="row">
      <div class="col-lg-12">
        <app-lfsa-input [control]="this.agregarFormCondicion.get('id_promo')" [id]="'id_promo'"
          [isReadOnly]="true" [label]="'ID PROMO'" formControlName="id_promo" type="text">
        </app-lfsa-input>
      </div>
  
      <div class="col-lg-12 mb-5">
        <label for="id_canal_cliente">Seleccione Conidición</label>
        <select class="form-control" formControlName="id_canal_cliente" id="id_canal_cliente">
          <option value="">Seleccione una opción</option>
          <option *ngFor="let data of comboList" [value]="data.idCanal">{{ data.idCanal + ' - ' + data.descCorta }}</option>
        </select>
      </div>
    </div>
  
    <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )"
      [formularioValido]="(!agregarFormCondicion.invalid) ? false : true"
      [textBoton]="'Guardar'" class="row">
    </app-lfsa-botones-formulario>
</form>
  
